module.exports = __webpack_public_path__ + "static/media/nullmeet2.1e8f69ce.jpeg";